export const PARSING_ERROR_MESSAGES = [
  'Make sure your JSON syntax is correct',
  'Remove any trailing commas',
  'All keys and strings must be double quotes',
];
